import { initializeLogger } from '@seamless/logger';
const logger = initializeLogger('DH-IO-SCCS/INFLATE');

export function appendUserContextToUrl(url?: string, ctx?: string, sortType?: string): string | undefined {
  if (!url) {
    return undefined;
  }

  try {
    const urlObject = new URL(url);
    const params = new URLSearchParams(urlObject.search);

    if (ctx && ctx !== 'DISABLED') {
      params.set('ctx', ctx);
      urlObject.search = params.toString();
    }

    params.set('emhsortType', sortType ?? '');
    urlObject.search = params.toString();

    return urlObject.toString();
  } catch (error) {
    logger.error('Invalid URL:', url, error);
    return url;
  }
}
